import { useGameSessionNav } from "../contexts/GameSessionContext";
import MemoryGamePreferenceDropdown from "./MemoryGamePreferenceDropdown";

export default function GameDifficultyFooter() {
  const { prepNavState } = useGameSessionNav();

  if (!prepNavState.visible || prepNavState.screen !== "difficulty") {
    return null;
  }

  return (
    <div className="game-difficulty-footer">
      <MemoryGamePreferenceDropdown />
    </div>
  );
}
